/**
 * Shared Schema.org structured data constants for omandisposables.com
 * Used across all product and landing pages.
 */

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://omandisposables.com';

/** Canonical LocalBusiness + Organization node — included on every page */
export const getOrganizationSchema = () => ({
  '@type': ['LocalBusiness', 'Organization'],
  '@id': `${SITE_URL}/#organization`,
  name: 'omandisposables.com',
  alternateName: 'Oman Disposables',
  url: SITE_URL,
  email: 'omandisposables@gmail.com',
  description:
    'Wholesale disposable gloves supplier based in Muscat, Oman. Medical surgical gloves, food grade gloves, industrial PPE gloves and lab gloves. Trusted supply across Oman and GCC.',
  priceRange: 'Wholesale',
  image: `${SITE_URL}/og-image.jpg`,
  logo: {
    '@type': 'ImageObject',
    url: `${SITE_URL}/og-image.jpg`,
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Muscat',
    addressRegion: 'Muscat Governorate',
    addressCountry: 'OM',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 23.5859,
    longitude: 58.4059,
  },
  areaServed: [
    { '@type': 'Country', name: 'Oman' },
    { '@type': 'Country', name: 'United Arab Emirates' },
    { '@type': 'Country', name: 'Saudi Arabia' },
    { '@type': 'Country', name: 'Kuwait' },
    { '@type': 'Country', name: 'Bahrain' },
    { '@type': 'Country', name: 'Qatar' },
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'omandisposables@gmail.com',
    availableLanguage: ['English', 'Arabic'],
    areaServed: ['OM', 'AE', 'SA', 'KW', 'BH', 'QA'],
  },
  knowsLanguage: ['en', 'ar'],
  sameAs: [],
});

/**
 * Generates a WebPage schema node for a given product page.
 */
export const getWebPageSchema = (params: {
  path: string;
  name: string;
  description: string;
  breadcrumbId: string;
}) => ({
  '@type': 'WebPage',
  '@id': `${SITE_URL}${params.path}#webpage`,
  url: `${SITE_URL}${params.path}`,
  name: params.name,
  description: params.description,
  inLanguage: ['en', 'ar'],
  isPartOf: { '@id': `${SITE_URL}/#organization` },
  breadcrumb: { '@id': params.breadcrumbId },
});

export { SITE_URL as SCHEMA_SITE_URL };